"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToolTipArrow = exports.ToolTip = void 0;

var styled_1 = __importDefault(require("@emotion/styled"));

var react_1 = require("@emotion/react");

var Enums_1 = require("../Enums");

exports.ToolTip = styled_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t", "\n"])), function (props) {
  var _ref = props || {},
      addClass = _ref.addClass,
      _ref$borderColor = _ref.borderColor,
      borderColor = _ref$borderColor === void 0 ? "" : _ref$borderColor,
      _ref$backColor = _ref.backColor,
      backColor = _ref$backColor === void 0 ? "" : _ref$backColor,
      _ref$hasClick = _ref.hasClick,
      hasClick = _ref$hasClick === void 0 ? false : _ref$hasClick;

  return (0, react_1.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\t\t", ";\n\t\t\t", ";\n\t\t\tmargin: 0px;\n\t\t\tborder: 1px solid ", ";\n\t\t\tbackground-color: ", ";\n\t\t\tz-index: ", ";\n\n\t\t\t&[data-popper-placement^=\"top\"] > #arrow {\n\t\t\t\tbottom: -5px;\n\t\t\t}\n\t\t\t&[data-popper-placement^=\"bottom\"] > #arrow {\n\t\t\t\ttop: -5px;\n\t\t\t}\n\t\t\t&[data-popper-placement^=\"left\"] > #arrow {\n\t\t\t\tright: -5px;\n\t\t\t}\n\t\t\t&[data-popper-placement^=\"right\"] > #arrow {\n\t\t\t\tleft: -5px;\n\t\t\t}\n\t\t"])), !!addClass ? addClass : "", hasClick ? "cursor: pointer;" : "", borderColor, backColor, Enums_1.IndexedLayers.modal);
});
exports.ToolTipArrow = styled_1.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\t", "\n"])), function (props) {
  return (0, react_1.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\t\t\tvisibility: hidden;\n\t\t\tposition: absolute;\n\t\t\twidth: 14px;\n\t\t\theight: 14px;\n\t\t\tbackground: inherit;\n\t\t\tz-index: ", ";\n\t\t\t::before {\n\t\t\t\tposition: absolute;\n\t\t\t\twidth: 14px;\n\t\t\t\theight: 14px;\n\t\t\t\tbackground: inherit;\n\t\t\t\tvisibility: visible;\n\t\t\t\tcontent: \"\";\n\t\t\t\ttransform: rotate(45deg);\n\t\t\t}\n\t\t"])), Enums_1.IndexedLayers.modal);
});